
import { combineConsolidationDegrees, hansboSpacingFactor, pvdEquivalentDiameter, pvdInfluenceDiameter, radialConsolidationDegree, verticalConsolidationDegree } from "./solver/consolidation";
import { calculateCircleSafetyFactor, searchCriticalCircle } from "./solver/slope-stability";
import { calculateConsolidationSettlement, effectiveStressIncrement, getDrainagePath, getThicknessWeightedCv, osterbergHalfInfluence, stripLoadInfluenceCenterline } from "./solver/settlement";
import { escapeHtml, formatDecimal, parseLocalizedNumber, sanitizeColor } from "./report/format";
import { createReportMetadata, projectChecksum } from "./report/metadata";
import { validateProject } from "./validation/project";
import { searchCriticalCircleAsync } from "./ui/slope-worker-client";
import { initStage3Ux } from "./ui/stage3";
import "./legacy/app.js";

export const core = {
  calculateConsolidationSettlement, effectiveStressIncrement, getDrainagePath, getThicknessWeightedCv,
  osterbergHalfInfluence, stripLoadInfluenceCenterline, verticalConsolidationDegree,
  pvdEquivalentDiameter, pvdInfluenceDiameter, hansboSpacingFactor, radialConsolidationDegree,
  combineConsolidationDegrees, calculateCircleSafetyFactor, searchCriticalCircle,
  searchCriticalCircleAsync, parseLocalizedNumber, formatDecimal, escapeHtml, sanitizeColor, validateProject,
  createReportMetadata, projectChecksum,
};

declare global {
  interface Window {
    NendatYeuCore: typeof core;
    XLSX: typeof import("xlsx") | undefined;
    html2pdf: typeof import("html2pdf.js").default | undefined;
  }
}

window.NendatYeuCore = core;
initStage3Ux();

const libraryButtons = ["btn-import-excel", "btn-export-excel", "btn-generate-pdf"];
function setLibraryButtonsDisabled(disabled: boolean): void {
  for (const id of libraryButtons) {
    const button = document.getElementById(id);
    if (button instanceof HTMLButtonElement) button.disabled = disabled;
  }
}

setLibraryButtonsDisabled(true);
void Promise.all([import("xlsx"), import("html2pdf.js")]).then(([xlsx, pdf]) => {
  window.XLSX = xlsx;
  window.html2pdf = pdf.default;
  setLibraryButtonsDisabled(false);
}).catch((error: unknown) => {
  console.error("Không thể tải thư viện Excel/PDF:", error);
});
